



















































































































































































































































































import { Component, Provide, Vue, Watch } from "vue-property-decorator";
import { getCookie, setCookie, delCookie } from "@/JS/cookie"; //使用getCookie方法
import httpApi from "@/API/Tenant/Weixin";
import Bus from "@/JS/Bus";
import wxTemplateList from "./wx-message_templateList.vue"; //模板列表页面
import wxTemplateEdit from "./wx-message_templateEdit.vue"; //添加编辑模板列表页面
@Component({
  components: {
    wxTemplateList: wxTemplateList,
    wxTemplateEdit: wxTemplateEdit,
    jsonView: function(resolve) {
      require(["vue-json-views"], resolve);
    }
  }
})
export default class extends Vue {
  @Provide() pageElement: string = "messageList";
  @Provide() expireDays: any = 1000 * 60 * 60;
  @Provide() SearchKeywords: string = "";
  @Provide() private GetAppData: any = {}; //取应用号信息
  @Provide() templateCategoryList: any = [];
  @Provide() viewLinkData: any = [];
  @Provide() OpenIDs: any = [];
  @Provide() optionFansList: any = [];
  @Provide() createCategoryForm: any = {
    cateoryValue: ""
  };
  @Provide() createRule: any = {
    cateoryValue: [
      { required: true, message: "请输入分组名称", trigger: "blur" },
      { min: 2, max: 10, message: "长度在 2 到 10 个字符", trigger: "blur" }
    ]
  };
  @Provide() createCategoryVisible: boolean = false;
  @Provide() testTemplateMessageVisible: boolean = false;
  @Provide() viewLinkVisible: boolean = false;
  @Provide() modifyCategoryIndex: number = 0;
  @Provide() categoryFiltrate: string = "全部";
  @Provide() wechatTemplateList: any;
  @Provide() messageTemplateList: any = [];
  @Provide() messageList: any = [];
  @Provide() currentMessage: any = "";
  @Provide() modifyIndex: string = "-1";
  @Provide() ModelTableID = ""; //当前公众号的ID
  @Provide() loading: boolean = false;
  @Provide() scrollHeight: number = 500;
  /** 加载初始化 */
  async created() {
    this.scrollHeight = document.body.scrollHeight - 180;
    // console.log(localStorage.getItem("pageName"));

    if (localStorage.getItem("pageName")) {
      this.pageElement = localStorage.getItem("pageName") as string;
    }
    if (!this.wechatTemplateList) {
      this.pageElement = "messageList";
    }
    let Aid = getCookie("Aid");
    let TenantID = getCookie("TenantID");
    this.GetAppData = {
      Aid: Aid,
      TenantID: TenantID
    };

    this.loadCategoryList();
    this.loadMessageList();
    this.loadGetMessageTemplateWeiXin();
    var that = this;
    Bus.$off("switchAccountFn");
    Bus.$on("switchAccountFn", (obj: any) => {
      that.GetAppData.Aid = obj.Aid;
      that.loadCategoryList();
      that.loadMessageList();
      that.loadGetMessageTemplateWeiXin();
    });
    // delCookie('pageName');
    // if(getCookie('pageName')==null){
    //   setCookie("pageName", 'messageList', this.expireDays);
    // }
    // console.log(this.pageElement);
  }
  //  监听公众号类型
  get tencentCode() {
    return this.$store.state.TencentInfoStore.typeCode;
  }
  @Watch("tencentCode", { immediate: false, deep: true })
  ontencentCode(val: string, oldVal: string) {
    // console.log("监听公众号类型: ");
    //console.log(val);
    //console.log(oldVal);
    if (this.$store.state.TencentInfoStore.aId) {
      this.GetAppData.Aid = this.$store.state.TencentInfoStore.aId;
    }
    this.loadCategoryList();
    this.loadMessageList();
    this.loadGetMessageTemplateWeiXin();
  }
  //测试弹出框选择人
  async remoteMethod(query: any) {
    if (query) {
      let AppAccount = this.GetAppData;
      if (AppAccount) {
        let params: any = {
          Input: [
            {
              Name: "AppFansSelect",
              Value: {
                Aid: AppAccount.Aid,
                NickName: query,
                OpenID: "",
                Sex: -1
              }
            },
            {
              Name: "Subscribe",
              Value: 1
            }
          ]
        };
        this.loading = true;
        this.optionFansList = [];
        var res: any = await httpApi.SarchFansList(params);
        console.log(res);

        this.loading = false;
        if (res.ErrorCode == 0) {
          // this.optionFansList =;
          res.output[0].value.forEach((element: any) => {
            this.optionFansList.push({
              label: element.NickName,
              value: element.OpenID,
              subscribe: element.IsSubscribe
            });
            //this.temOptionList.push({ label: element.ElementName, value: element.ElementCode })
          });
          this.$forceUpdate();
          //console.log(this.optionFansList);
        } else {
          this.$router.push("/");
          //  this.$message.error("失败：" + res.ErrorMessage);
        }
      }
    }
  }
  /*看查链接 */
  getviewLinkVisible(index: number) {
    this.viewLinkVisible = true;
    this.viewLinkData = this.messageList[index];
    this.viewLinkData.miniprogram = JSON.parse(this.viewLinkData.miniprogram);
  }
  /*测试模板消息 */
  getTemplateMessageVisible(index: number) {
    this.testTemplateMessageVisible = true;
    this.viewLinkData = this.messageList[index];
    this.viewLinkData.miniprogram = JSON.parse(this.viewLinkData.miniprogram);
    // console.log(this.viewLinkData);
  }
  /*提交后台发送测试模板消息 */
  async submitTestTemplateMessage() {
    if (this.OpenIDs.length < 1) {
      this.$message.info("请选择接收对象！");
    } else {
      let subData = this.viewLinkData;
      subData.miniprogram = JSON.stringify(this.viewLinkData.miniprogram);
      let params: any = {
        Input: [
          {
            Name: "OpenIDs",
            Value: JSON.stringify(this.OpenIDs)
          },
          {
            Name: "Model",
            Value: JSON.stringify(subData)
          }
        ]
      };
      var res = await httpApi.GetTestTemplateWeiXin(params);
      if (res.ErrorCode == 0) {
        this.$message.success("测试发送成功！");
        this.testTemplateMessageVisible = false;
      } else {
        this.$message.error("测试发送失败：" + res.ErrorMessage);
      }
    }
  }
  //列表
  async loadGetMessageTemplateWeiXin() {
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.GetAppData.Aid //消息模板类型
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.GetMessageTemplateWeiXin(params);
    if (res.ErrorCode == 0) {
      //console.log(res);
      this.wechatTemplateList = res.output[0].value;
      // console.log(this.wechatTemplateList);
    } else {
      this.$router.push("/");
      // this.$message.error("读取失败：" + res.ErrorMessage);
    }
  }
  //设置页面跳转cookies
  setPageElement(pe: string) {
    localStorage.setItem("pageName", pe);
    this.pageElement = pe;
  }
  /** 清除localStorage */
  removeLocalStorage() {
    localStorage.removeItem("wxTemplate");
    localStorage.removeItem("modifyIndex");
  }
  /** 新增模板消息 */
  toAdsMessage(addData: string) {
    this.removeLocalStorage();
    this.setPageElement(addData);
  }
  /**
   * 修改模板消息
   */
  toModifyMessage(modifyData: any) {
    this.removeLocalStorage();
    this.setPageElement(modifyData[0]);
    this.currentMessage = this.messageList[modifyData[1]];
    this.modifyIndex = modifyData[1];
  }
  /*删除模板数据 */
  toDeleteMessage(deleteData: any) {
    this.$confirm("此操作将永久删除该条记录, 是否继续?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        var submitData = this.messageList[deleteData];
        submitData.Status = 0;
        submitData.ActionName = "DELETE";
        // console.log(submitData);
        let params: any = {
          Input: [
            {
              Name: "Model",
              value: submitData
            },
            {
              Name: "AID",
              Value: this.GetAppData.Aid
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SaveModel(params);

        // console.log(res);
        if (res.ErrorCode == 0) {
          this.loadMessageList();
          this.$message({
            type: "success",
            message: "删除成功!"
          });
        } else {
          this.$router.push("/");
          //this.$message.error(res.ErrorMessage);
        }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
  }
  /**
   * 新建模板消息分类
   */
  async submitCreateCategoryForm(formName: any) {
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (valid) {
        let message = "";
        let subData = {
          ActionName: "CREATE",
          ApplicationId: this.GetAppData.Aid,
          TypeName: this.createCategoryForm.cateoryValue,
          Sid: this.templateCategoryList.length + 1,
          TypeId: 0
        };
        if (this.modifyCategoryIndex == 0) {
          message = "添加成功！";
        } else {
          subData.ActionName = "UPDATE";
          subData.Sid = this.modifyCategoryIndex;
          subData.TypeId = this.templateCategoryList[
            this.modifyCategoryIndex
          ].TypeId;
          message = "修改成功！";
        }
        //添加模板消息分类
        this.createCategoryVisible = false;
        // this.$message({
        //   message: message,
        //   type: "success"
        // });
        let params: any = {
          Input: [
            {
              Name: "Model",
              Value: subData
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SaveAppMessageTemplateType(params);
        if (res.ErrorCode == 0) {
          this.$message.success("保存成功！");
          // if (subData.ActionName == "CREATE") {
          //   this.templateCategoryList.push({
          //     temp_name: this.createCategoryForm.cateoryValue,
          //     counts: 0,
          //     TypeId: 0
          //   });
          // } else {
          //   this.templateCategoryList[
          //     this.modifyCategoryIndex
          //   ].temp_name = this.createCategoryForm.cateoryValue;
          // }
          this.loadCategoryList();
        } else {
          this.$message.error("保存失败：" + res.ErrorMessage);
        }
      } else {
        return false;
      }
    });
  }
  /*加载模板数据 */
  async loadMessageList() {
    let params: any = {
      Input: [
        {
          Name: "aid",
          Value: this.GetAppData.Aid
        },
        {
          Name: "status",
          Value: 1
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.GetAppMessageTemplateList(params);
    if (res.ErrorCode == 0) {
      var result = res.output[0].value;
      if (this.SearchKeywords) {
        result = result.filter((item: any, index: any) =>
          item.template_title.includes(this.SearchKeywords)
        );
      }
      this.messageList = result;
      this.messageTemplateList = result;
      // console.log(result);
    } else {
      this.$router.push("/");
      //this.$message.error(res.ErrorMessage);
    }
  }
  /*加载分类列表 */
  async loadCategoryList() {
    let params: any = {
      Input: [
        {
          Name: "Model",
          Value: { ApplicationId: this.GetAppData.Aid, Status: 1 }
        }
      ]
    };
    var res: any = await httpApi.GetAppMessageTemplateType(params);
    if (res.ErrorCode == 0) {
      this.templateCategoryList = [];
      // console.log(res.output[0].value);
      res.output[0].value.forEach((el: any) => {
        this.templateCategoryList.push({
          temp_name: el.TypeName,
          counts: el.Counts,
          TypeId: el.TypeId
        });
      });
    } else {
      this.$message.error("保存失败：" + res.ErrorMessage);
    }
  }
  /** 取消新增模板分组 */
  resetCreateCategoryForm(formName: any) {
    this.createCategoryVisible = false;
    (this.$refs[formName] as any).resetFields();
    this.modifyCategoryIndex = 0;
    this.createCategoryForm.cateoryValue = "";
  }
  // 自定义模板分组修改
  modifyCate(index: number) {
    this.createCategoryVisible = true;
    this.createCategoryForm.cateoryValue = this.templateCategoryList[
      index
    ].temp_name;
    this.modifyCategoryIndex = index;
  }
  async moveCate(mIndex: number, cate: any, dir: number) {
    //需要移动的数据
    let moveCate = this.templateCategoryList[mIndex];
    if (dir == 1) {
      if (mIndex == 1) {
        this.$message({
          type: "info",
          message: "不能上移!"
        });
        return false;
      }
      //上移
      this.templateCategoryList.splice(mIndex - 1, 0, cate);
      this.templateCategoryList.splice(mIndex + 1, 1);
    } else {
      if (mIndex == this.templateCategoryList.length - 1) {
        this.$message({
          type: "info",
          message: "不能下移!"
        });
        return false;
      }
      this.templateCategoryList.splice(mIndex + 2, 0, cate);
      this.templateCategoryList.splice(mIndex, 1);
    }
    let params: any = {
      Input: [
        {
          Name: "Model",
          Value: this.templateCategoryList
        },
        {
          Name: "aid",
          Value: this.GetAppData.Aid
        }
      ]
    };
    var res: any = await httpApi.UpdateAppMessageTemplateTypeSid(params);
    // console.log(res);
  }
  //移除模板分组
  async removeCate(index: number) {
    this.$confirm("确认删除该分组吗?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        if (this.templateCategoryList[index].counts != 0) {
          this.$message({
            type: "info",
            message: "该分类下有模板信息，不能删除!"
          });
          return false;
        }
        let params: any = {
          Input: [
            {
              Name: "Model",
              Value: {
                ActionName: "DELETE",
                TypeId: this.templateCategoryList[index].TypeId
              }
            }
          ]
        };
        // console.log(params);
        var res: any = await httpApi.SaveAppMessageTemplateType(params);
        if (res.ErrorCode == 0) {
          this.$message.success("删除成功!");
          this.templateCategoryList.splice(index, 1);
        } else {
          this.$message.error("删除失败：" + res.ErrorMessage);
        }
      })
      .catch(() => {
        this.$message({
          type: "info",
          message: "已取消删除"
        });
      });
  }
  //分类筛选
  categoryShow(temp: any) {
    this.categoryFiltrate = temp;
  }
  addMessStep(stepData: any) {
    this.setPageElement(stepData[0]);
    if (stepData[1] != -1) {
      var obj = this.wechatTemplateList[stepData[1]];
      this.currentMessage = {
        ActionName: "CREATE",
        AID: this.GetAppData.Aid,
        ID: 0,
        TemplateContentText: "",
        TenantID: this.GetAppData.TenantID,
        TypeID: 0,
        Url: "",
        create_time: "",
        template_id: obj.template_id,
        template_name: obj.title,
        template_title: obj.title,
        data: JSON.parse(obj.data),
        miniprogram: '{"appid": "", "pagepath": "", "pagepath2": "" }',
        skipUrl: "",
        skipUrlType: "",
        template_category: ""
      };
    }
  }
  /*取消保存 */
  cancelMessage() {
    this.loadCategoryList();
    this.loadMessageList();
  }
  /** 新增保存 */
  async saveMessage(saveData: any) {
    this.setPageElement(saveData[0]);

    var submitData = saveData[1];
    submitData.miniprogram = JSON.stringify(saveData[1].miniprogram);
    submitData.TypeCode = "TypeCode_003";
    submitData.TypeName = "模板消息";
    // console.log(submitData);
    let params: any = {
      Input: [
        {
          Name: "Model",
          value: submitData
        },
        {
          Name: "AID",
          Value: this.GetAppData.Aid
        }
      ]
    };
    //console.log(params);
    var res: any = await httpApi.SaveModel(params);
    // console.log(res);
    if (res.ErrorCode == 0) {
      this.$message.success("保存成功！");
      if (saveData[2] == "-1") {
        //新增
        this.messageList.push(saveData[1]);
        saveData[1].ActionName = "CREATE";
      } else {
        //修改
        this.messageList[saveData[2]] = saveData[1];
      }
      this.loadCategoryList();
      this.loadMessageList();
    } else {
      this.$router.push("/");
      //this.$message.error("保存失败：" + res.ErrorMessage);
    }
    // this.pageElement = saveData[0];
  }
}
